
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/meta-catalog",
      function () {
        return require("private-next-pages/destinations/meta-catalog.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/meta-catalog"])
      });
    }
  